import $ from 'jquery';

$('.blog-filter').on('change', (e) => {
    const url = $(e.target).val();
    window.location.href = url;
});
